import React from 'react';

import type { LucideIcon } from '../../../../../common/icons/lucide-adapter';
import { Card, CardContent, CardHeader } from '@/components';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/atoms';

type ReportWrapperProps = {
  title?: React.ReactNode;
  children: React.ReactNode;
  tooltip?: string;
  Icon?: LucideIcon;
  showTooltip?: boolean;
  headerAction?: React.ReactNode;
};

export const ReportWrapper: React.FC<ReportWrapperProps> = ({
  title,
  children,
  tooltip,
  Icon,
  showTooltip = true,
  headerAction,
}) => {
  return (
    <Card className="mb-6 rounded-3xl bg-white">
      {title && (
        <CardHeader className="flex flex-row items-center justify-between px-10 pb-4 pt-10">
          <div className="flex items-center gap-2">
            <h2 className="text-xl font-semibold" style={{ color: '#14203D' }}>
              {title}
            </h2>

            {tooltip && showTooltip && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="ml-1 flex h-4 w-4 cursor-help items-center justify-center">
                      <span className="text-xs font-medium" style={{ color: '#C1C1C1' }}>
                        ?
                      </span>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent side="top" className="max-w-xs">
                    <p className="text-sm">{tooltip}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
          {headerAction && <div>{headerAction}</div>}
        </CardHeader>
      )}

      <CardContent className="px-10 pb-10 pt-0">{children}</CardContent>
    </Card>
  );
};
